import React from "react";
import PropTypes from "prop-types";
import styles from "../../css/styles.css";

var Suggestion = function Suggestion(_ref) {
  var main = _ref.main,
      secondary = _ref.secondary;
  return React.createElement("div", null, React.createElement("div", {
    className: styles['suggestion-main']
  }, main), React.createElement("div", {
    className: styles['suggestion-secondary']
  }, secondary));
};

process.env.NODE_ENV !== "production" ? Suggestion.propTypes = {
  main: PropTypes.node,
  secondary: PropTypes.node
} : void 0;
export default Suggestion;